import { type Enum } from '@webapp/utils'

export const CostAdjustmentTypes = {
  percent: 'percent',
  amount: 'amount',
  /**
   * @techdebt This is a legacy type that is passed and returned from the backend
   * in PO object for discount and taxes cost adjustment types
   */
  percentage: 'percentage',
}

export type CostAdjustmentType = Enum<typeof CostAdjustmentTypes>

export const CostAdjustmentSymbols = {
  percent: '%',
  percentage: '%',
  amount: '$',
}

export type CostAdjustmentSymbol = Enum<typeof CostAdjustmentSymbols>
